export const useGetParams = () => {
  const searchParams = new URL(document.location).searchParams;
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user'),

    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,

    title: getDefaultValue(
      searchParams.get('title'),
      'Какая ценность\\nдля вас самая важная?'
    ),
    qrTitle1: getDefaultValue(searchParams.get('qrTitle1'), 'Telegram'),
    qrCode1: searchParams.get('qrCode1'),
    qrTitle2: getDefaultValue(searchParams.get('qrTitle2'), 'WhatsApp'),
    qrCode2: searchParams.get('qrCode2'),

    sizeQR: searchParams.get('sizeQR') || '17.2',
    paddingQR: searchParams.get('paddingQR') || '0',
    titleFontSize: searchParams.get('titleFontSize') || '3.1',
    minFontWords: searchParams.get('minFontWords') || 30,
    maxFontWords: searchParams.get('maxFontWords') || 70,
    requestInterval: Number(searchParams.get('requestInterval') || 2000),
    demo: searchParams.get('demo') || false,

    // phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || 5,
  };
};
